export default __webpack_public_path__ + "static/media/arena_16.30502a30.jpeg";